"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardRequirementsComponent = void 0;
var vue_1 = require("vue");
exports.CardRequirementsComponent = vue_1.default.component('CardRequirements', {
    props: {
        requirements: {
            type: Object,
            required: true,
        },
    },
    methods: {
        getClasses: function () {
            var classes = ['card-requirements'];
            if (this.requirements.hasMax()) {
                classes.push('card-requirements-max');
            }
            return classes.join(' ');
        },
    },
    template: "\n        <div v-if=\"requirements.hasParty()\" :class=\"getClasses()\">\n            <span class=\"party\">{{ requirements.getRequirementsText() }}</span>\n        </div>\n        <div v-else-if=\"requirements.hasPlantsRemoved()\" :class=\"getClasses()\"> \n            <div class=\"card-special card-minus\"></div>\n            <div class=\"card-resource card-resource-plant red-outline\"></div>\n        </div>\n        <div v-else :class=\"getClasses()\">{{ requirements.getRequirementsText() }}</div>\n    ",
});
//# sourceMappingURL=CardRequirementsComponent.js.map